import { render, staticRenderFns } from "./box.vue?vue&type=template&id=2673e7cc&scoped=true"
import script from "./box.vue?vue&type=script&lang=js"
export * from "./box.vue?vue&type=script&lang=js"
import style0 from "./box.vue?vue&type=style&index=0&id=2673e7cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2673e7cc",
  null
  
)

export default component.exports